import axios from 'axios';

const state = {
  reminders: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchReminders({ commit, dispatch }, params) {
    dispatch('loading/showLoading', null, { root: true });

    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/reminders`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      const data = await response.data;
      commit('setReminders', data.data);
      commit('setPagination', data.pagination);
    }
    catch (error) {
      console.error('Failed to fetch reminders: ', error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },
  clearReminders({ commit }) {
    commit('CLEAR_REMINDERS');
  },

  async fetchAllReminders({ commit }) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/reminders`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      commit('setReminders', response.data.data);
    } catch (error) {
      console.error('Failed to fetch all reminders:', error);
      throw new Error('Could not fetch reminders. Please try again later.');
    }
  },

  async createReminder({ commit }, reminder) {
    try {
      const token = localStorage.getItem('auth_token');

      const response = await axios.post(`${process.env.VUE_APP_ROOT_API}/reminders`, reminder, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      commit('addReminder', response.data); // Pastikan ini sesuai dengan struktur respons API
      return response.data;
    } catch (error) {
      console.error('Failed to create reminder:', error);
      throw new Error('Could not create reminder. Please try again later.');
    }
  },

  async fetchReminderById({ dispatch }, id) {
    dispatch('loading/showLoading', null, { root: true });
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/reminders/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error('Failed to fetch reminder by ID:', error);
      throw new Error('Could not fetch reminder details. Please try again later.');
    } finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },

  async updateReminder({ commit }, reminder) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/reminders/${reminder.id}`, reminder, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      commit('updateReminder', response.data);
      return response.data;
    }
    catch (error) {
      console.error('Failed to update reminder:', error);
    }
  },

  async deleteReminderById({ commit }, id) {
    try {
      const token = localStorage.getItem('auth_token');
      await axios.delete(`${process.env.VUE_APP_ROOT_API}/reminders/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      commit('removeReminder', id);
    } catch (error) {
      console.error('Failed to delete reminder', error);
      throw new Error('Could not delete reminder. Please try again later.');
    }
  },
};

const mutations = {
  setReminders(state, reminders) {
    state.reminders = reminders;
  },

  setPagination(state, pagination) {
    state.pagination = {
      page: pagination.page || state.pagination.page,
      perPage: pagination.perPage || state.pagination.perPage,
      totalItems: pagination.totalItems || 0,
      previousPageLink: pagination.previousPageLink ? pagination.previousPageLink.replace(/\/api\/v1\/reminders\?/, '') : null,
      nextPageLink: pagination.nextPageLink ? pagination.nextPageLink.replace(/\/api\/v1\/reminders\?/, '') : null
    };
  },

  addReminder(state, reminder) {
    state.reminders.push(reminder);
  },

  updateReminder(state, updateReminder) {
    const index = state.reminders.findIndex(reminder => reminder.id == updateReminder.id);
    if (index !== -1) {
      state.reminders.splice(index, 1, updateReminder);
    }
  },
  removeReminder(state, id) {
    state.reminders = state.reminders.filter(reminder => reminder.id !== id);
  },
  CLEAR_REMINDERS(state) {
    state.reminders = [];
    state.pagination = {};
  }
};

const getters = {
  allReminders: (state) => state.reminders,
  pagination: (state) => state.pagination
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
